export default "__VITE_ASSET__DkubrT7e__"